// SPDX-License-Identifier: Apache-2.0

// /sessions — live Claude Code fleet. Auto-refreshes every 5s.
// All UI lives in <SessionsLive />; this file is the route shell.
import SessionsLive from "../components/SessionsLive";

export default function Sessions() {
  return (
    <section style={{ padding: "32px 24px 80px", "max-width": "1100px", margin: "0 auto" }}>
      <div class="kicker">/sessions</div>
      <h2 style={{ "margin-top": "8px", "margin-bottom": "12px" }}>
        Live sessions room
      </h2>
      <p style={{ "margin-bottom": "10px" }}>
        Every Claude Code agent on this machine, in one fleet view. Click a
        card to expand for files modified, recent errors, and last activity.
      </p>
      <p style={{ "margin-bottom": "24px", color: "var(--text-dim)", "font-size": "13.5px" }}>
        Sessions are background <code>claude</code> processes — one per
        project. Start one by asking the brain at{" "}
        <a href="/chat" style={{ color: "var(--accent)" }}>/chat</a> ("spawn a
        session for X"), summoning the{" "}
        <a href="/temple" style={{ color: "var(--accent)" }}>/temple</a>, or
        running <code>claude</code> in any terminal — they appear here within
        a few seconds.
      </p>
      <SessionsLive />
    </section>
  );
}
